import Swiper from 'swiper'
import { Autoplay } from 'swiper'

export default function initSwiper() {
  if (window.location.pathname === '/careers/') {
    function getContainerLeftOffset(selector) {
      const container = document.querySelector(selector)
      if (!container) return 0

      const computedStyle = window.getComputedStyle(container)
      return parseFloat(computedStyle.paddingLeft)
    }

    function initializeFluidSwiper() {
      const containerSelector = '.a-container.inside'
      const offset = getContainerLeftOffset(containerSelector)

      const careerSwiper = new Swiper('.swiper', {
        modules: [Autoplay],
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 16,
        autoplay: {
          delay: 2000
        },
        slidesOffsetBefore: offset,
        slidesOffsetAfter: 16,
        on: {
          resize: function () {
            const newOffset = getContainerLeftOffset(containerSelector)
            this.params.slidesOffsetBefore = newOffset
            this.update()
          }
        }
      })
    }
    initializeFluidSwiper()
  } else {
    const swiper = new Swiper('.swiper', {
      modules: [Autoplay],
      slidesPerView: 'auto',
      spaceBetween: 16,
      autoplay: {
        delay: 2000
      }
    })
  }
}
